import api, {HTTPMethod} from '@/helpers/api'
import {z} from 'zod'

export const GenerateDamTokenResponseSchema = z.object({
  expires_in: z.number(),
  access_token: z.string(),
})

export type GenerateDamTokenResponse = z.infer<typeof GenerateDamTokenResponseSchema>

export const BrandMetadataSchema = z.object({
  dam_id: z.string(),
  dam_brand_ids: z.array(z.string()).optional(),
  not_applicable: z.boolean().optional(),
})

export const BrandSchema = z.object({
  id: z.string(),
  name: z.string(),
  metadata: BrandMetadataSchema.optional(),
})

export const ListBrandsAndSubbrandsResponseSchema = z.object({
  brands: z.array(BrandSchema),
  subBrands: z.array(BrandSchema),
})

export type ListBrandsAndSubbrandsResponse = z.infer<typeof ListBrandsAndSubbrandsResponseSchema>

/**
 * Generate a token for Bynder
 *
 * - Create endpoint: POST /api/bynder/token
 * - Should call Bynder API to generate a temporary access token
 * - Returns: { expiresAt: ISO date string, accessToken: string }
 */
export const generateDamTokenService = () => {
  return api<Record<string, never>, GenerateDamTokenResponse>({
    method: HTTPMethod.GET,
    path: '/api/integrations/bynder/auth',
    requestSchema: z.object({}),
    responseSchema: GenerateDamTokenResponseSchema,
  })({})
}

export const listBrandsAndSubbrandsService = (signal?: AbortSignal) => {
  return api<Record<string, never>, ListBrandsAndSubbrandsResponse>({
    method: HTTPMethod.GET,
    path: '/api/bynder/brands',
    requestSchema: z.object({}),
    responseSchema: ListBrandsAndSubbrandsResponseSchema,
    signal,
  })({})
}
